
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import photography from "../images/photography.jpg"
import certificateImg from "../images/certificate.png"
import getHelpImg from "../images/get-help.svg"
import facebookImg from "../images/facebook.jpg"
import tiktokImg from "../images/tiktok.png"
import klaviyoImg from "../images/klaviyo.png"
import wordpressImg from "../images/wordpress.png"
import googleALogoImg from "../images/google-adwords-logo.png"
import howWorkImg from "../images/how-does-work.jpg"
import dmInstructor from "../images/dm-instructor.jpg"
import Testimonial from "../home/testimonial"
import $ from "jquery"
import Slider from "react-slick";
import "../css/slick.css"; 
import "../css/slick-theme.css";
import { storage } from "../firebase";
import { courseRef, database } from '../firebase'
import parse from 'html-react-parser';
var ii=0;
export default class CourseDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
        CourseName: '',       
        id: null,        
        bannerTitle: "",
        bannerDescription: "",
      
        modelRight: [],
        whatyoudo_Description: "",
        rightModelTitle: "",
       
        WhatYouWillLearnArray: [],
      
        WhatYouWillGetArray:[],
       
        HowdoesitworkArray:[],
        PlatformsToolsFiles:[],
  
      
        CertificationsFiles:[],
      
       
        



    }

}
  componentDidMount(){
    let url_path = window.location.href.split("=");
        let keyId = (url_path[1]);
        this.renderList(keyId)
    
    var acc = document.getElementsByClassName("accordion");
    var i;
    
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }

    $('.get-help-right-button').click(function() {
      $('.get-help-right-button.gTactive').removeClass('gTactive'); 
      $(this).addClass('gTactive'); 
    })
  }

  async renderList(keyId) {
   
    //let dataList = []
    let id = keyId;
    const ref = id ? '/Course/' + id : 'Course'
    const userRef = database.ref(ref)
    const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
    const snapshot = await valueRef.once('value')
    const val = snapshot.val()
    if (val) {
  
        this.setState({
            CourseUrl: val.imageUrl,
            id: id,
            CourseName: val.CourseName,
            bannerTitle: val.bannerDetails[0].title,
            bannerDescription: val.bannerDetails[0].description,
            whatyoudo_Description: val.whatyoudo_Description,
            rightModelTitle: val.whatyoudo_rightModel[0].rightModelTitle,
            modelRight: val.whatyoudo_rightModel[0].modelData,
            WhatYouWillLearnArray: val.WhatYouWillLearn,
            WhatYouWillGetArray:val.WhatYouWillGet,
            HowdoesitworkArray:val.Howdoesitwork,
            PlatformsToolsFiles:val.PlatformsToolsFiles,
            CertificationsFiles:val.CertificationsFiles


        })
    }
    else{
   
    }
}

accordionClick(key){ 
$(".panel").hide();  
$("#panel"+key).show();
$(".accordion").removeClass("active"); 
$("#accordion"+key).addClass("active");   
}
accordionWork(key){ 
  $(".panelWork").hide();  
  $("#panelWork"+key).show();
  $(".accordion").removeClass("active"); 
  $("#accordionClick"+key).addClass("active");  
}
getHelpClick(key){ 
  $('.get-help-right-button.gTactive').removeClass('gTactive'); 
  $('.get-help-right-button'+key).addClass('gTactive'); 
}
    render() {
      const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      };

    return (

      <div className="main-wrapper course-det-wrapper">
        <div className="heaerBgImg">
          <Header></Header>
          
          <div className='row head-top-section'>
            <div className='col-md-6' style={{position:"relative"}}>
              <div className='insights-det-head mb-0'>
                  <h4>{this.state.bannerTitle}</h4>
                  <p className='my-4'>{parse(this.state.bannerDescription)}</p>
                  <button className='btn-theme btn-sm'>Get Free Guidence</button>
              </div>
            </div>
            <div className='col-md-6 bg-icons'>
            </div>
          </div>
        </div>
        <div className="main-content p-0"> 
            <section>
              <div className="container px-4 course-det-what-do">
                <div className="row">
                  <div className="col-md-7">
                    <div className='insights-det-head'>
                      <h4 className='mb-4'>What you'll do</h4>
                      {parse(this.state.whatyoudo_Description)}
                      
                      <a className='readmore' href="#">read more</a>
                    </div>
                  </div>
                  
                  <div className='col-lg-4 mt-5 mt-lg-0 offset-md-1'>
                    <div className="courses-det-box">
                      <div>
                        <div className='course-det-rate'> {this.state.rightModelTitle} </div>
                        <div className='courses-det-box-list'>
                        {this.state.modelRight.map((data, i) => {
                                                        return (
                                                          <div className='courses-det-box-list'>
                                                          <div className='courses-det-box-bottom'>
                                                            <span className='courses-det-box-bottom-left'> {data.date} </span>
                                                            <span className='courses-det-box-bottom-right'>{data.price}</span>
                                                          </div>
                                                          <div className='courses-det-box-bottom'>
                                                            <small className='d-block'>{data.duration}</small>
                                                              <button className='btn-theme btn-sm'>Get Guidence</button>
                                                          </div>
                                                        </div>
                                                        )})}
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-12 course-det-learn'>
                <div className='container px-4'>
                  <div className='insights-det-head mb-0'>
                      <h4>What You Will Learn</h4>
                  </div>
                  <div className="get-accordian">
                   
                    {this.state.WhatYouWillLearnArray.map((data, i) => {
                   
                                                    return (
                    <div className='accordion-list'>
                      <button className="accordion" id={'accordion'+i} onClick={()=>this.accordionClick(i)}>
                        <span>{data.title}</span>
                      </button>
                      <div className="panel" id={'panel'+i} style={{display: 'none'}}>
                      {parse(data.description)}
                      </div>
                    </div>
                    
                                                    )})}


                  </div>
                </div>
              </div>

              <div className="course-det-what-get">
                <div className="row">
                  <div className='col-md-7 col-lg-8'>
                    <div className='course-det-what-get-Content'>
                      <div className='insights-det-head mb-0'>
                          <h4>What You Will Get</h4>
                      </div>
                      <div className="course-det-what-get-img">
                        <img src={getHelpImg} className="img-fluid"></img>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-5 col-lg-4'>
                    <div className="get-help-right">
                      <div className="get-help-right-lists">
                      {this.state.WhatYouWillGetArray.map((data, i) => {
                                                    return (
                                                      <div className={"get-help-right-button get-help-right-button"+i} onClick={()=>this.getHelpClick(i)}>
                       {data.title}
                        </div>
                                                    )})}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='platform-tools-main'>
                <div className='container'>
                  <div className='insights-det-head'>
                      <h4>Platforms & Tools</h4>
                  </div>
                  <div className='row mt-3 platform-tools-list'>
                  {this.state.PlatformsToolsFiles.map((data, i) => {
                                                    return (
                    <div className='platform-tools-img'>
                      <img src={data.url} className='img-fluid mb-2'></img>
                    </div>
                                                    )})}
                  </div>
                </div>
              </div>

              <div className="course-det-what-get how-does-work-main">
                <div className="row">
                  <div className='col-md-7 col-lg-7'>
                    <div className='course-det-what-get-Content'>
                      <div className='insights-det-head'>
                          <h4>How does it work</h4>
                      </div>
                      <div className="course-det-what-get-img mt-0">
                        <img src={howWorkImg} className="img-fluid"></img>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-5 col-lg-5'>
                    <div className="how-work-right">
                      <div className='insights-det-head mb-0'>
                          <h4>How does it work</h4>
                      </div>
                      <div className="how-work-accordion">
                      {
                        this.state.HowdoesitworkArray.map((data, i) => {
                          ii=ii+1
                                                    return (
                                                      <span>
                       <button className="accordion" id={"accordionClick"+i} onClick={()=>this.accordionWork(i)}> {data.title} <span>0{ii}</span></button>
                        
                       
                        
                        <div className="panel panelWork" id={"panelWork"+i} style={{display: 'none'}}>
                        {parse(data.description)}
                        </div>
                        </span>        )})}
                        
                        
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className='certification-main'>
                  <div className='insights-det-head'>
                      <h4>Certifications</h4>
                  </div>
                  <div className='row mt-3'>
                 
                    <Slider {...settings}>  
                    {this.state.CertificationsFiles.map((data, i) => {
                                                    return (
                      <div className='certification-list'>
                        <img src={data.url} className='img-fluid mb-5'></img>
                      </div>
                                                    )})}
                    </Slider>
                  </div>
              </div>
                
              <Testimonial></Testimonial>

              
              <div className="container px-4 course-det-what-do">
                <div className="row">
                  <div className="col-md-12">
                    <div className='insights-det-head'>
                      <h4 className='mb-4'>Meet Your Instructor</h4>
                    </div>
                    <div className='teacher-head'>
                      <div className="teacher-left">
                        <div className="teacher-name">Firoz Khan</div>
                        <div className="teacher-designation">E-commerce Expert</div>
                        <div className="rating">
                          <div className="stars">
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                          </div>
                          <p> total reviews</p>
                        </div>
                        <a href="/" className="btn-theme">View All Course</a>
                      </div>
                      <div className="teacher-right">
                        <img src={dmInstructor} alt="" className="teacher-img" />
                      </div>
                    </div>
                    <div className='insights-det-head'>
                      <p>I am a Growth Digital Marketing professional with over 8 years of expertise, specialized in working with established companies for securing and growing their business.  I have assisted organizations in acquiring and retaining customers from various digital channels by using multiple growth strategies.</p>
                      <p>Being part of two world-class cities (Singapore & Dubai) helped me acquire expertise and insights by understanding the patterns and underlying principles of the digital fields...</p>
                      <a className='readmore' href="#">read more</a>
                    </div>
                  </div>
                </div>
              </div>

        </section>
        </div>
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/ivano/course-details.jsx